import { render, staticRenderFns } from "./CardPublisherDetail.vue?vue&type=template&id=2fc1f554&"
import script from "./CardPublisherDetail.vue?vue&type=script&lang=js&"
export * from "./CardPublisherDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports